// 회사 정보 구조화 데이터(Organization JSON-LD) — SEO 요구사항 A-5.
// AI/검색엔진이 "코드프레소가 어떤 회사인지" 판단할 공식 근거 데이터.
// useSiteNavigationLd와 동일한 useHead script 주입 패턴.
export const useOrganizationLd = () => {
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Codepresso",
    "legalName": "코드프레소",
    "url": "https://codepresso.io",
    // ponytail: 전용 로고 파일이 public에 없어 og_image로 대체 — 정사각 로고 확보 시 교체
    "logo": "https://codepresso.io/main/og_image.png",
    "email": "support@codepresso.io",
    "sameAs": [
      "https://www.linkedin.com/company/codepresso/",
      "https://blog.codepresso.io",
      "https://blog.naver.com/code-presso"
    ]
  };

  return { type: 'application/ld+json', innerHTML: JSON.stringify(organization) };
};
